module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDAgMTAwIiB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCI+PHBhdGggZD0iTTc3LjUgODFoLTU1Yy00LjQxIDAtOC0zLjU5LTgtOFY0OGg2djI1YzAgMS4wOC45MiAyIDIgMmg1NWMxLjUgMCAzLjQyLTEuMzMgMy45NS0yLjc0bDUuNzQtMTUuMzIgNS42MiAyLjExLTUuNzQgMTUuMzJjLTEuNCAzLjcyLTUuNiA2LjYzLTkuNTcgNi42M3oiLz48cGF0aCBkPSJNNzcuNSAyNS41YzAtMi43NS0yLjI1LTUtNS01aC00MGMtMi43NSAwLTUgMi4yNS01IDV2NDBjMCAyLjc1IDIuMjUgNSA1IDVoNDBjMi43NSAwIDUtMi4yNSA1LTV2LTQweiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/car-features/payload.svg
// module id = qAcX
// module chunks = 1